import { useParams } from "@tanstack/react-router";
import DossierTechniqueForm from "@features/creation/dossier-techniques/components/DossierTechniqueForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import { useDossierTechniqueDetail } from "@features/creation/dossier-techniques/hooks/useDossierTechniques";

export const Route = createFileRoute("/_app/creation/dossier-techniques/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.EDIT),
  staticData: {
    title: "Modifier le dossier technique",
    icon: Pencil,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditDossierTechniquePage,
});

function EditDossierTechniquePage() {
  const { id } = useParams({ from: "/_app/creation/dossier-techniques/$id/edit" });
  const { data: dossier, isLoading } = useDossierTechniqueDetail(id);

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Modifier le dossier technique</h1>
        </div>
        <div className="space-y-4">
          <div className="skeleton h-12 w-full" />
          <div className="skeleton h-24 w-full" />
          <div className="skeleton h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier le dossier technique</h1>
        <p className="text-sm text-base-content/60">
          Modifier les informations du dossier {dossier?.reference}
        </p>
      </div>
      <DossierTechniqueForm dossier={dossier} />
    </div>
  );
}